import { z } from 'zod';

import { zodFilteredProjectsQueryParametersSchema } from '~/data/ai';

export const zodFilteredProjectsRouterSearchParamsSchema =
  zodFilteredProjectsQueryParametersSchema
    .omit({
      forceRefresh: true,
    })
    .extend({
      page: z.number().nonnegative().optional().prefault(0),
      searchString: z.string().trim().optional().prefault(''),
    });
